import { PaymentMethod, PaymentMethodType } from '../gql-types.generated';

// Display names for the payment method category column. Exhaustive by design - adding a value to
// PaymentMethodType will fail the build here until it is given a display name.
export const paymentMethodTypeDisplay: Record<PaymentMethodType, string> = {
  [PaymentMethodType.CreditCard]: 'Card',
  [PaymentMethodType.PaymentBankUs]: 'ACH',
};

/**
 * Card/ACH category for a payment, kept separate from the combined payment method column which
 * renders the brand and last four. Renders blank rather than a raw enum value when there is no
 * category to show: payments settled entirely by credit memo carry no payment method, and a type
 * the schema has gained since this build was generated has no display name here.
 */
export const getPaymentMethodTypeDisplay = (isCreditPayment: boolean, paymentMethod?: PaymentMethod | null): string => {
  const methodType = paymentMethod?.type;

  if (isCreditPayment || !methodType) {
    return '';
  }

  return paymentMethodTypeDisplay[methodType] ?? '';
};
